import script from "./basketChange.vue?vue&type=script&setup=true&lang=ts"
export * from "./basketChange.vue?vue&type=script&setup=true&lang=ts"

import "./basketChange.vue?vue&type=style&index=0&id=09c04256&lang=scss&scoped=true"

import exportComponent from "D:\\code\\idea2023\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09c04256"]])

export default __exports__